import React,{useState} from "react"
import EditButton from "./EditButton";
import PollEditor from "./PollEditor";
import PollSelector, { ACTIVE, RESULT } from "./PollSelector";
import ActivePoll from "./ActivePoll";
import PreviousPoll from "./PreviousPoll";
import { useGlobal } from "./Reducer";
 export default (props)=>
    {

      const [showPollSelector,setShowPollSelector]=useState(false);
      const [pollMode,setPollMode]=useState(ACTIVE);  
      const [gs,ga]=useGlobal();
        
        
        
        return (<div className="container panel-right nopadding">
        
      {showPollSelector && <PollSelector mode={pollMode} onClose={()=>setShowPollSelector(false)} />}
        <div className="row">
      
      
      <div className="col " >
      
       {(gs.adminMode==true || gs.appData.active_poll_id) && <ActivePoll editButton={   <EditButton  onClick={()=>{
                setPollMode(ACTIVE);
                setShowPollSelector(true);
              }}/> }/>}
      </div>
      </div>
      
      <div className="row">
      
      
      <div className="col ">
     
      
          {(gs.adminMode==true || gs.appData.result_poll_id) &&     <PreviousPoll  editButton={   <EditButton  onClick={()=>{
                setPollMode(RESULT);
                setShowPollSelector(true);
              }}/> }/>}
      </div>
      </div>
      
      </div>
      );
    }

